'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import type { ICity } from '@/entities/common/types/city';
interface CityListProps {
  cities: ICity[];
  currentCityAlias: string;
}
export const CityList: React.FC<CityListProps> = ({
  cities,
  currentCityAlias
}) => {
  const t = useTranslations('shared.header.cityModal');
  const getCityLink = (city: ICity) => {
    const url = new URL(window.location.href);
    let path = {
      pathname: ``,
      search: ''
    };
    if (url.pathname.includes('/doctor/') || url.pathname.includes('/medcenter/')) {
      path = {
        pathname: `/${city.alias}`,
        search: ''
      };
    } else {
      path = {
        pathname: `${url.pathname.replace('/kk', '').replace(currentCityAlias, city.alias)}`,
        search: url.search.replace('?', '')
      };
    }
    return path;
  };
  if (cities.length === 0) {
    return <div className="py-8 text-center text-gray-500">{t('notFound')}</div>;
  }
  return <div data-sentry-component="CityList" data-sentry-source-file="CityList.tsx">
      <p className="my-4 text-lg">{t('popular')}</p>
      <div className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-3">
        {cities.map(city => <Link href={getCityLink(city)} key={city.id} className="text-sm font-bold text-gray-700 transition-colors duration-200 hover:text-blue-600">
            {city.name}
          </Link>)}
      </div>
    </div>;
};